export default __webpack_public_path__ + "static/1-032756063121b097a6f97e99eeebc8d5.jpg";